// "Record the rest of this call?" (owner request, PJ, 2026-10-20: "I want the meetings that we booked to have been
// recorded or something after and then be posted somewhere in the Discord or the dialer for us to listen to the meetings
// that were booked."). Opened by "Record (they said yes)" on the call bar of a connected call the recording rule skipped
// for all-party consent. It tells the setter to ask first, word for word, and only "They said yes, start" starts the
// recording. No key starts it (a click on purpose, or Enter on that focused button); Esc or a click outside cancels.
// H hangs up and M mutes while it is open (review 2026-10-20: the dialer's own hotkeys stand down for any dialog and the
// backdrop covers the call bar, so the confirm takes those two keys itself and has its own Hang up button: a prospect
// who says "no, and I have to go" is never kept waiting on Esc first). It closes by itself when the call ends.
// Mounted once in PhoneProvider, next to RedialConfirm.
import { useEffect, useRef } from 'preact/hooks';
import { useExternal } from '../components/ui-extra';
import { CONSENT_RECORDING_ASK, CONSENT_RECORDING_ON, consentConfirmKey, consentConfirmOpen } from './consentRecord';
import { cancelConsentRecording, getDialer, hangup, startConsentRecording, subscribeDialer, toggleMute } from './store';

export function ConsentRecordConfirm() {
  const s = useExternal(subscribeDialer, getDialer);
  const open = consentConfirmOpen(s.call, s.consentRec);
  const box = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    box.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      const action = consentConfirmKey(e);
      if (!action) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (action === 'cancel') cancelConsentRecording();
      else if (action === 'hangup') { cancelConsentRecording(); hangup(); }
      else if (action === 'mute') toggleMute();
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [open]);

  if (!open) return null;
  return (
    <div class="vd-confirm-backdrop" onClick={(e) => { if (e.target === e.currentTarget) cancelConsentRecording(); }}>
      <div ref={box} class="card vd-confirm" role="alertdialog" aria-modal="true" aria-labelledby="vd-consent-title"
        aria-describedby="vd-consent-body" tabIndex={-1}>
        <h2 id="vd-consent-title">Record the rest of this call?</h2>
        <div id="vd-consent-body">
          <p>Ask first: <b>"{CONSENT_RECORDING_ASK}"</b> Start only after they say yes.</p>
          <p>Once it's on, say it out loud: <b>"{CONSENT_RECORDING_ON}"</b></p>
        </div>
        <p class="muted" style="font-size:13px">Their state needs everyone's consent to record. If they say no, cancel: the call goes on, unrecorded, and your notes become the closer brief.</p>
        <div class="row" style="gap:8px;flex-wrap:wrap">
          <button type="button" class="btn btn-primary" onClick={(e) => { (e.currentTarget as HTMLElement).blur(); void startConsentRecording(); }}>
            They said yes, start
          </button>
          <button type="button" class="btn" onClick={(e) => { (e.currentTarget as HTMLElement).blur(); cancelConsentRecording(); }}>
            Cancel <kbd>Esc</kbd>
          </button>
          <button type="button" class="btn btn-danger" style="margin-left:auto" onClick={(e) => { (e.currentTarget as HTMLElement).blur(); cancelConsentRecording(); hangup(); }}>
            Hang up <kbd>H</kbd>
          </button>
        </div>
      </div>
    </div>
  );
}
